import { DownloadButton } from '../../../../components/DownloadButton';
import { useGrowers } from '../../../../hooks/use-growers';
import { useContext } from '../../context';
import * as api from '../../../../lib/api.js';

export function CsvButton() {
  const { arePrescriptionsSelected, getSelectedPrescriptionIds } = useContext();
  const { selectedId: growerId } = useGrowers();

  return (
    <DownloadButton
      disabled={!arePrescriptionsSelected}
      keep-open="true"
      download={() =>
        api.downloadLpkCsv(growerId, getSelectedPrescriptionIds())
      }
    >
      Export CSV
    </DownloadButton>
  );
}
